<template>
  <PreGameModal :progress="progress" :progressTotal="progressTotal">
    <template #content>
      <transition mode="out-in" name="fade">
        <div class="content" v-if="step === 0">
          <div class="title">Quelques conseils pour une expérience optimale</div>
          <div class="listWrapper">
            <ul class="list">
              <li><b>Si vous utilisez un ordinateur portable, branchez-le au secteur</b> : pour éviter de ne pas avoir
                suffisamment de batterie</li>
              <li><b>Utilisez un casque ou des écouteurs</b> : pour mieux vous concentrer, profiter des dialogues, et
                vous
                immerger dans l’ambiance de l’aventure</li>
              <li><b>Prenez un papier et un crayon</b> : il pourraient s’avérer utiles pour noter des informations clés
              </li>
              <li><b>Branchez votre une souris si vous en avez une</b> : durant l’aventure, vous pourriez la trouver
                plus
                agréable qu’un pavé tactile</li>
            </ul>
          </div>
          <div class="buttons">
            <Button label="Quitter" class="btn secondary outline" @click="$emit('back')" />
            <Button label="Continuer" class="btn primary" @click="Next" />
          </div>
        </div>
        <div class="content" v-else>
          <div class="header">
            <div class="iconWrapper">
              <i class=" icon bi-exclamation" />
            </div>
            <div class="title">Avertissement épilepsie</div>
            <div class="text">Certains jeux vidéos peuvent provoquer des crises chez les personnes sensibles. Si vous
              avez
              des antécédents de crises ou de troubles liés aux convulsions, consultez un médecin avant de jouer.</div>
          </div>
          <div class="buttons">
            <Button label="Quitter" class="btn secondary outline" @click="$emit('back')" />
            <Button label="Continuer" class="btn primary" @click="Next" />
          </div>
        </div>
      </transition>
    </template>
  </PreGameModal>
</template>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  width: 100%;

  gap: 40px;

  .title {
    font-size: 32px;
    font-weight: 700;
  }

  .listWrapper {
    align-self: stretch;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;

    padding: 24px;

    border-radius: 6px;
    border: 2px solid #464646;


    .list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;

      b {
        color: #F2CB36;
        font-weight: 700;
      }
    }
  }

  .buttons {
    display: flex;
    gap: 16px;

    .btn {
      border: 2px solid #464646 !important;
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin: 8px 0;
    }

    .text {
      text-align: center;
      font-size: 18px;
    }

    .iconWrapper {
      width: 64px;
      height: 64px;

      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      font-size: 48px;

      background-color: #F2CB36;
      color: black;

      margin-top: 24px;
    }
  }
}
</style>

<script setup lang="ts">
import { ref } from 'vue';

import PreGameModal from './PreGameModal.vue';

const step = ref(0);

defineProps({
  progress: {
    type: Number,
    required: true,
  },
  progressTotal: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits([
  'back',
  'next',
]);

function Next() {
  if (step.value === 0) {
    // If we have already seen the epilepsy warning, we can skip it
    if (localStorage.getItem('sawEpilepsyWarning') === 'true') {
      emit('next');
    }
    // Else we show the epilepsy warning
    else if (localStorage.getItem('sawEpilepsyWarning') === 'false') {
      step.value = 1;
    }
    else {
      step.value = 1;
      localStorage.setItem('sawEpilepsyWarning', 'true');
    }
  }

  // If we are on the epilepsy warning, we can go to the next step
  else if (step.value === 1) {
    emit('next');
  }
}

</script>